export enum StoreMutationType {
  LOGIN = 'login',
  LOGOUT = 'logout',
  SET_LOGIN_REDIRECT_PATH = 'set_login_redirect_path',
  SET_LAST_ACTIVE_DATE = 'set_last_active_date',
  SET_FLASH_MESSAGE = 'SET_FLASH_MESSAGE',
  SET_HAS_ERROR = 'SET_HAS_ERROR',

  SET_TOWER_CANVAS_SELECTION_TYPE = 'SET_TOWER_CANVAS_SELECTION_TYPE',
  SET_GRID_MODE = 'SET_GRID_MODE',
  SET_LEGEND_MODE = 'SET_LEGEND_MODE',
  SET_SNAP_TO_MODE = 'SET_SNAP_TO_MODE',
  SET_TOWER_CONTEXT_MENU_STATE = 'SET_TOWER_CONTEXT_MENU_STATE',
  SET_TOWER_SELECTED_OBJECT = 'SET_TOWER_SELECTED_OBJECT',
  SET_TOWER_CONFIG_CHANGE = 'SET_TOWER_CONFIG_CHANGE',
  SET_TOWER_CANVAS_ZOOM_LEVEL = 'SET_TOWER_CANVAS_ZOOM_LEVEL',
  UPDATE_TOWER_POLICY_OBJECT = 'UPDATE_TOWER_POLICY_OBJECT',
  UPDATE_CANVAS_OBJECTS_ARRAY = 'UPDATE_CANVAS_OBJECTS_ARRAY',
  SET_TOWER_DISPLAY_OPTIONS = 'SET_TOWER_DISPLAY_OPTIONS',
  EDIT_TOWER_DISPLAY_OPTIONS = 'EDIT_TOWER_DISPLAY_OPTIONS',
  EDIT_POLICY_RECT = 'EDIT_POLICY_RECT',
  EDIT_POLICY_LINE_RECT = 'EDIT_POLICY_LINE_RECT',
  SET_PROGRAMS_PANEL_STATE = 'SET_PROGRAMS_PANEL_STATE',
  SET_CURRENT_TOWER_INSTANCE = 'SET_CURRENT_TOWER_INSTANCE',
  ADD_FABRIC_OBJECT_TO_CANVAS = 'ADD_FABRIC_OBJECT_TO_CANVAS',
  REMOVE_FABRIC_OBJECT_FROM_CANVAS = 'REMOVE_FABRIC_OBJECT_FROM_CANVAS',
  SET_TOWER_VERSIONS = 'SET_TOWER_VERSIONS',
  ADD_TOWER_VERSION = 'ADD_TOWER_VERSION',
  SET_PROGRAM_POLICIES = 'SET_PROGRAM_POLICIES',
  SET_CUSTOM_POLICIES = 'SET_CUSTOM_POLICIES',
  DUPLICATE_FABRIC_OBJECT = 'DUPLICATE_FABRIC_OBJECT',
  DELETE_FABRIC_OBJECT = 'DELETE_FABRIC_OBJECT',
  SET_PROGRAM_ID = 'SET_PROGRAM_ID',
  SET_ACCOUNT_ID = 'SET_ACCOUNT_ID',
  SET_PROGRAM_NAME = 'SET_PROGRAM_NAME',
  SET_ACCOUNT_NAME = 'SET_ACCOUNT_NAME',
  SET_EDIT_MODE = 'SET_EDIT_MODE', // this is for canvas editing, not to be confused with IS_EDITING which is used to bypass keypresses for keymaps in the v2 tower
  SET_LOAD_ERROR = 'SET_LOAD_ERROR',
  ACCEPT_LEGAL_DISCLAIMER = 'ACCEPT_LEGAL_DISCLAIMER',
  SET_CANVAS_CHANGE_REASON = 'SET_CANVAS_CHANGE_REASON',
  ADD_TOWER_HISTORY = 'ADD_TOWER_HISTORY',
  UNDO_TOWER_HISTORY = 'UNDO_TOWER_HISTORY',
  REDO_TOWER_HISTORY = 'REDO_TOWER_HISTORY',
  RESET_TOWER_HISTORY = 'RESET_TOWER_HISTORY',
  SET_ACTIVE_CANVAS_OBJECT = 'SET_ACTIVE_CANVAS_OBJECT ',
  TOWER_EXPORT_FILE_TYPE = 'TOWER_EXPORT_FILE_TYPE',
  SHOW_TOWER_EXPORT_OPTIONS = 'SHOW_TOWER_EXPORT_OPTIONS',
  SHOW_VISUALIZER_EXPORT_OPTIONS = 'SHOW_VISUALIZER_EXPORT_OPTIONS',
  SET_IS_EDITING = 'SET_IS_EDITING',
  EDIT_TOWER_INFO = 'EDIT_TOWER_INFO',
  SET_TOWER_EDITOR_EXPANDED = 'SET_TOWER_EDITOR_EXPANDED',
  SET_TOWER_EDITOR_VISIBLE = 'SET_TOWER_EDITOR_VISIBLE',
  EDIT_PUBLISH_TOWER_MODAL_STATE = 'EDIT_PUBLISH_TOWER_MODAL_STATE',
  SET_LIMIT_PREMIUM_COUNTER_MODE = 'SET_LIMIT_PREMIUM_COUNTER_MODE',
  SET_RENEWAL_PROCESSED = 'SET_RENEWAL_PROCESSED',
  SET_DELETED_PROGRAM_MODE = 'SET_DELETED_PROGRAM_MODE',

  // ************
  // Client View
  // ************

  ENABLE_CLIENT_VIEW_MODE = 'ENABLE_CLIENT_VIEW_MODE',
  DISABLE_CLIENT_VIEW_MODE = 'DISABLE_CLIENT_VIEW_MODE',
  ADD_CLIENT_VIEW = 'ADD_CLIENT_VIEW',
  DELETE_CLIENT_VIEW = 'DELETE_CLIENT_VIEW',
  UPDATE_CLIENT_VIEW = 'UPDATE_CLIENT_VIEW',
  SET_SHOW_CLIENT_VIEWS_MODAL = 'SET_SHOW_CLIENT_VIEWS_MODAL',
  RESET_CLIENT_VIEW_PERMISSIONS = 'RESET_CLIENT_VIEW_PERMISSIONS',
  ADD_CLIENT_VIEW_PERMISSION = 'ADD_CLIENT_VIEW_PERMISSION',
  REMOVE_CLIENT_VIEW_PERMISSION = 'REMOVE_CLIENT_VIEW_PERMISSION',

  SET_NOTIFICATIONS = 'SET_NOTIFICATIONS',

  ADD_RESIZE_REGISTRY_ITEM = 'ADD_RESIZE_REGISTRY_ITEM',
  REMOVE_RESIZE_REGISTRY_ITEM = 'REMOVE_RESIZE_REGISTRY_ITEM',
  UPDATE_RESIZE_REGISTRY_ITEM = 'UPDATE_RESIZE_REGISTRY_ITEM',
}
